import {
  CheckboxSection,
  Container,
  InputSection,
} from "./CheckableInputStyles";

function CheckableInput(props) {
  const { value, onChangeValue, placeholder, checked, onChangeCheck } = props;
  return (
    <Container height={props.height} width={props.width} checked={checked}>
      <InputSection
        value={value}
        placeholder={placeholder}
        onChange={onChangeValue}
        checked={checked}
        readOnly={!checked}
      />
      <CheckboxSection
        checked={checked}
        type="checkbox"
        onChange={onChangeCheck}
      />
    </Container>
  );
}

export default CheckableInput;
